<template>
	<component :is="tag" v-bind="linkProps" @click="handleClick" role="listitem" class="settings-list-item relative flex items-center divided px-16 lg:px-24 py-16 lg:py-20"
			   :class="{'is-clickable': to || clickable}">
		<div v-if="icon" class="mr-16">
			<Icon :icon="icon" color="gray-400" small/>
		</div>
		<div class="flex flex-column overflow-hidden flex-grow-x-1">
			<p v-if="title" class="text-sub font-heading text-heading-color font-semi-bold mb-0 leading-tight">{{ title }}</p>
			<div v-if="description" class="text-sm text-subtext-color mb-0 mt-4 leading-spaced whitespace-pre-wrap" v-html="description"/>

			<slot/>
		</div>
		<div class="flex flex-column ml-16">
			<Icon v-if="!$slots.right && to" :icon="icons.next" color="gray-400"/>
			<slot name="right"/>
		</div>
	</component>
</template>

<script>
import Linkable from "../../../mixins/Linkable";
import {nextIcon} from "../../../config";

export default {
	name: "SettingsListItem",

	mixins: [Linkable],


	props: {

		title: {
			type: String,
			default: null
		},

		description: {
			type: String,
			default: null
		},

		icon: {
			type: String,
			default: null
		},
	},

	data() {
		return {
			icons: {
				next: nextIcon,
			}
		}
	},

	computed: {

		tag() {
			if (this.absoluteTo) {
				return 'a';
			}
			if (this.relativeTo) {
				return resolveComponent('NuxtLink');
			}

			return 'div';
		},

	},
}
</script>

<style>
/*********************
  Inputs
**********************/
.settings-list-item.is-clickable:hover {
  cursor: pointer;
  background-color: #fafafa;
}
</style>